/* tslint:disable */
/* eslint-disable */
/**
 * Hyper-Timesheet.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  ClientiResponseDTO,
  ProblemDetails,
} from '../models/index';
import {
    ClientiResponseDTOFromJSON,
    ClientiResponseDTOToJSON,
    ProblemDetailsFromJSON,
    ProblemDetailsToJSON,
} from '../models/index';

export interface GetClientiRequest {
    idPersonale?: number;
}

/**
 * 
 */
export class ClientiApi extends runtime.BaseAPI {

    /**
     */
    async getClientiRaw(requestParameters: GetClientiRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<ClientiResponseDTO>>> {
        const queryParameters: any = {};

        if (requestParameters['idPersonale'] != null) {
            queryParameters['idPersonale'] = requestParameters['idPersonale'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("oauth2", ["Hyper.Timesheet"]);
        }

        const response = await this.request({
            path: `/api/Clienti`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(ClientiResponseDTOFromJSON));
    }

    /**
     */
    async getClienti(requestParameters: GetClientiRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<ClientiResponseDTO>> {
        const response = await this.getClientiRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
